<template>
    <div class="Shop">
        <menuBox :step="4"></menuBox>
        <div class="title-box">
            <p>CONTACT US</p>
            <div>If you have any cooperation ideas or are interested in our products, please feel free to contact us</div>
        </div>
        <div class="contact-us">
            <div class="contact-box">
                <div class="mali-box">
                    <div class="mali-item">
                        <img src="../assets/icon-3.png" alt="">
                        <div>
                            <p>Email</p>
                            <div>kcl.group.cos@gmail.com</div>
                        </div>
                    </div>
                </div>
                <div class="text-box">
                    <div>Opening hours</div>
                    <p>Monday to Friday: 10 am - 6 pm</p>
                    <p>Sunday: 10 am - 3 pm</p>
                </div>
                <div class="text-box">
                    <div>Address</div>
                    <p>C/O RAJENDRA KUMAR JAGDAMBA COLOY MAIN ROAD WARD NO 15 DABRA Gwalior MP 475110 IN</p>
                </div>
            </div>
            <div class="us-box">
                <div class="title">WANT TO GET IN TOUCH WITH US?</div>
                <div class="sbtitle">No problem, fill out the form below and we will get back to you.</div>
                <div class="inpu-box">
                    <input type="text" placeholder="">
                    <input type="text" placeholder="">
                    <input type="text" placeholder="">
                    <textarea name="Text1" class="msg-box" cols="40" rows="5"></textarea>
                </div>
                <div class="send">Send Message</div>
            </div>
        </div>

        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {
        aboutUs() {
            this.$router.push({ path: "aboutUs" });
        }
    }
}
</script>
<style lang="less" scoped>
.title-box {
    background-image: url(../assets/product-1.png);
    background-size: 100% 100%;
    width: 100%;
    height: 450px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    color: #FFFFFF;

    p {
        font-size: 64px;
        font-weight: bold;
    }

    div {
        margin-top: 32px;
        width: 900px;
    }
}

.contact-us {
    padding: 120px 300px;
    display: flex;
    align-items: self-start;
    justify-content: space-between;

    .contact-box {
        width: 420px;

        .mali-box {
            padding: 30px 22px;
            background: #F8F8F8;

            .mali-item {
                display: flex;
                align-items: center;
                justify-content: space-between;

                img {
                    width: 60px;
                }

                div {
                    font-size: 22px;
                    font-weight: 600;
                    color: #333333;
                }

                p {
                    font-size: 16px;
                    font-weight: 600;
                    color: #999999;
                }
            }
        }

        .text-box {
            margin-top: 35px;
            padding: 30px 22px;
            background: #F8F8F8;

            div {
                font-size: 22px;
                font-weight: 600;
                color: #333333;
                margin-bottom: 20px;
            }

            p {
                font-size: 16px;
                color: #999999;
                // margin-top: 20px;
            }
        }
    }

    .us-box {
        .title {
            font-size: 40px;
            font-family: Bebas;
            color: #333333;
            font-weight: bold;
        }

        .sbtitle {
            font-size: 16px;
            color: #999999;
            margin-top: 30px;
        }

        .inpu-box {
            margin-top: 40px;
            width: 700px;

            input {
                width: 700px;
                padding: 0px 20px;
                height: 48px;
                background: #F8F8F8;
                margin-bottom: 17px;
                border: none;
                outline: medium;
                font-size: 16px;
            }

            .msg-box {
                width: 700px;
                padding: 20px;
                background: #F8F8F8;
                height: 140px;
                word-break: break-word;
                border: none;
                outline: medium;
                font-size: 16px;
            }
        }

        .send {
            width: 240px;
            height: 71px;
            background: #3B8056;
            font-size: 20px;
            font-weight: 600;
            color: #FFFFFF;
            margin-top: 24px;
            text-align: center;
            line-height: 71px;
        }
    }
}
</style>
